module.exports = __webpack_public_path__ + "img/cute_natural_doodle_9.14bc72e0.png";